import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "Common/Components/examples/Sidenav";
import theme from "Common/hooks/assets/theme";
import { useSoftUIController } from "Common/hooks/context";
import brand from "Common/hooks/assets/images/lmsLogo1.png";
import Login from "Common/Auth/SignIn";
import DashboardLayout from "Common/Components/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "Common/Components/examples/Navbars/DashboardNavbar";
import { showSidebar } from "Common/Client/routeUtils";
import { getRoutes } from "Common/Client/routeUtils";
import Register from "Common/Auth/SignUp";
import routes from "./ProAdminRoutes";
import CoursesList from "../Courses/CourseList";
import CORIQPROLandingPage from "../dashboard/CORIQPROLandinPage";
import CourseDetails from "../Courses/CourseDetails";
import CreateCoursePage from "../Courses/CreateCourse";
import AddModulePage from "../Courses/AddModule";
import ModuleDetails from "../Courses/ModuleDetails";
import ReadCourseDetails from "../Courses/ReadCourseDetail";
import EditAssessmentPage from "../Courses/EditAssessment";
import PageDetails from "../Courses/PageDetails";
import CategoriesList from "../Categories/CategoriesList";
import OrganizationDetailPage from "../dashboard/OrganizationalDetailView";
import AuthorsList from "../Authors/AuthorsList";
import AdminPaymentLedgerPage from "../PaymentLedger/PaymentLedgers";
import PaymentLedgerDetailPage from "../PaymentLedger/PaymentLedgerDetail";
import ReportsPage from "../Reports/Reports";
import LearnerReport from "../Reports/LearnerReport";
import OrganizationReport from "../Reports/OrganizatinReport";
import CourseReport from "../Reports/CourseReport";
import LearnerActivitiesReport from "../Reports/LearnerActivities";
import CourseEnrollmentsReport from "../Reports/EnrollemntCourseReport";
import LedgersReport from "../Reports/LedgersReport";
import ExpertServices from "../Expert/ExpertServices";
import CreateServicePage from "../Expert/CreateService";
import EditExpertSupport from "../Courses/EditExpertService";

function ProAdminContent() {
  const [controller] = useSoftUIController();
  const { layout, sidenavColor } = controller;
  const location = useLocation();

  useEffect(() => {
    sessionStorage.setItem("currentPath", location.pathname);
    console.log(" Current ProAdmin Route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {layout === "dashboard" && showSidebar && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={brand}
              brandName="Admin"
              routes={routes}
            />
          </>
        )}
        <DashboardLayout>
          <DashboardNavbar />
          <Routes>
            {/* Dashboard Route */}
            <Route path="/" element={<CORIQPROLandingPage />} />
            
            {/* Courses Route */}
            <Route path="/courses" element={<CoursesList />} />
            <Route path="/categories" element={<CategoriesList/>}/> 
            <Route path="/authors" element={< AuthorsList/>} />
            <Route path="/payment-ledgers" element={< AdminPaymentLedgerPage/>} />
  <Route 
          path="/payment-ledger-detail/:ledgerId" 
          element={<PaymentLedgerDetailPage />} 
        />

{/*Reports */}
             <Route path="/reports" element={< ReportsPage/>} />
    <Route path="/learner-report" element={<LearnerReport />} />
<Route path="/organization-report" element={<OrganizationReport />} />
<Route path="/course-report" element={<CourseReport />} />
<Route path="/learner-activities-report" element={<LearnerActivitiesReport />} />
<Route path="/course-enrollments-report" element={<CourseEnrollmentsReport />} />
<Route path="/ledgers-report" element={<LedgersReport/>} />


            <Route path="courses/:courseId" element={<CourseDetails />} /> 
             <Route path="courseDetails/:courseId" element={<ReadCourseDetails />} />
            <Route path="courses/create" element={<CreateCoursePage />} />
            <Route path="courses/:courseId/edit" element={<CreateCoursePage />} />
            <Route path="courses/:courseId/add-module" element={<AddModulePage />} />
            <Route path = "courses/:courseId/modules/:moduleId" element = {<ModuleDetails/>} />
            <Route path="courses/:courseId/modules/:moduleId/edit-assessment"  element={<EditAssessmentPage />} />
            <Route 
                path="courses/:courseId/modules/:moduleId/pages/:pageId" 
                element={<PageDetails />} 
            />
            <Route path="/organization-detail/:organizationId" element={< OrganizationDetailPage/>}/>
            {/* Expert Service Routes*/}
            <Route path="/expert-services" element={< ExpertServices/>}/>
            <Route path="services/create" element={<CreateServicePage />} />
<Route path="services/edit/:serviceId" element={<CreateServicePage />} />
<Route path="courses/:courseId/expert-support/:serviceId/edit" element={<EditExpertSupport />} />  
            
            {/* Other Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            {/* Catch-all route */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </DashboardLayout>
      </ThemeProvider>
    </>
  );
}

export default ProAdminContent;